<template>
	<div id="dashboard-subtemplate">
		completed surveys
	</div>
</template>

<script>

// import CreateProgressBar from '../common/Create/CreateProgressBar';
// import LoginPanel from '../common/Login/LoginPanel';


export default {
	data(){
		return {

		}
	},
	methods : {
		
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/DashboardCompletedSurveys.vue